import { ApplicationConfig, inject, provideExperimentalZonelessChangeDetection } from '@angular/core';
import { provideRouter, RouteReuseStrategy, withNavigationErrorHandler, NavigationError } from '@angular/router';
// NOTE: provideClientHydration intentionally disabled — see providers below.
// import { provideClientHydration, withIncrementalHydration } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { META_REDUCERS, provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { DataEffects } from '../store/store.effects';
import { provideToastr } from 'ngx-toastr';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { storeObject } from './store/storeObject';
import { storeStorageMetaReducer } from './store/storeStorage';
import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { SimpleReuseStrategy } from './reuse.strategy';
import { authInterceptor } from './auth.interceptor';
import { routes } from './app.routes';
import { CryptoService } from './store/crypto.service';

export const AppConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withNavigationErrorHandler((error: NavigationError) => {
        const chunkFailedPattern = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i;

        const message: string = error.error?.message ?? String(error.error ?? '');

        if (chunkFailedPattern.test(message)) {
          window.location.href = error.url ?? window.location.href;
        }
      })
    ),
    { provide: RouteReuseStrategy, useClass: SimpleReuseStrategy },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    provideExperimentalZonelessChangeDetection(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideStore(storeObject, {
      // metaReducers: [(reducer) => storeStorageMetaReducer(inject(CryptoService))(reducer)],
    }),
    {
      provide: META_REDUCERS,
      multi: true,
      deps: [CryptoService],
      useFactory: (crypto: CryptoService) => {
        return (reducer: any) => storeStorageMetaReducer(crypto)(reducer);
      },
    },
    provideToastr(),
    DatePipe,
    provideEffects([DataEffects]),
    provideAnimationsAsync(),
  ],
};
